import React from "react";
import styles from "./TextArea.module.scss";
const TextArea = () => {
  return (
    <div className={styles.container}>
      <p className={styles.text}>
        Do you have what it takes to make the next hyper or hybrid-casual hit?
        Be the next wave in the world of gaming with MondayOFF! By participating
        in MondayOFF Party and submitting a game in these genres, you can
        showcase your exceptional skills and get noticed.
      </p>
    </div>
  );
};

export default TextArea;
